<script>
import { openExternalLink } from "@/utility/open-external-link";

export default {
  name: "InformationModalButton",
  props: {
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false,
      default: null
    },
    showModal: {
      type: String,
      required: false,
      default: null
    },
  },
  methods: {
    openAssociatedModal() {
      Modal[this.showModal].show();
    },
    openLink() {
      openExternalLink(this.link);
    },
    handleClick() {
      if (this.link) this.openLink();
      else if (this.showModal) this.openAssociatedModal();
      else player.gotSTD = true;
    }
  }
};
</script>

<template>
  <span
    :ach-tooltip="name"
    class="c-socials--icon__wrapper"
  >
    <a
      class="c-socials--icon"
      @click="handleClick"
    >
      <i :class="icon" />
    </a>
  </span>
</template>

<style scoped>
.c-socials--icon {
  color: var(--color-text);
  cursor: pointer;
}

.c-socials--icon__wrapper {
  transition: all .2s ease-in-out;
}

.c-socials--icon__wrapper:hover {
  transform: scale(1.1);
}

.o-std {
  color: #ffca57;
}

[ach-tooltip]:before {
  width: 20rem;
  font-size: 1.5rem;
}
</style>
